import React, { useState, useEffect } from 'react'
import { MySwal } from '../../../lib/swal'
import axios from '../../../lib/axios'
import errorHandler from '../../../helpers/errorHandler';
import { getIdProvinsi } from '../../../helpers/getIdProvinsi';
import { getIdKota } from '../../../helpers/getIdKota';
import { getIdKecamatan } from '../../../helpers/getIdKecamatan';

const FormEditPicIndividu = (props) => {

    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])
    const [subDistricts, setSubDistricts] = useState([])

    const [disabled, setDisabled] = useState(false);
    const [required, setRequired] = useState(false);
    const [NamaDepan, setNamaDepan] = useState(props.user.firstName);
    const [NamaBelakang, setNamaBelakang] = useState(props.user.lastName);
    const [HpPic, setHpPic] = useState(props.user.mobilePhone);
    const [EmailPic, setEmailPic] = useState(props.user.email);
    const [IdentityFile, setIdentityFile] = useState(props.user.identityFile);
    const [IdentityType, setIdentityType] = useState(props.user.identityType);
    const [IdentityNumber, setIdentityNumber] = useState(props.user.identityNumber);
    const [Job, setJob] = useState(props.user.job);
    const [NamaPerusahaan, setNamaPerusahaan] = useState(props.user.companyName);
    const [JobPosition, setJobPosition] = useState(props.user.jobPosition);
    const [ProvinsiIndividu, setProvinsiIndividu] = useState(props.user.Account.billingState);
    const [KotaIndividu, setKotaIndividu] = useState(props.user.Account.billingCity);
    const [KecamatanIndividu, setKecamatanIndividu] = useState(props.user.Account.billingSubdistrict);
    const [PatokanIndividu, setPatokanIndividu] = useState(props.user.Account.billingStreet);
    const [Kodepos, setKodepos] = useState(props.user.Account.billingZip);

    const handleUpdate = async () => {
        try {
            // setDisabled(true)
            console.log(Job.length)
            if (
                EmailPic.length === 0 ||
                NamaBelakang.length === 0 ||
                IdentityType.length === 0 ||
                IdentityNumber.length === 0 ||
                Job.length === 0 ||
                HpPic.length === 0
            ) {
                // alert('masuk atas')
                // return false
                setRequired(true)
                MySwal.fire({
                    position: 'top-end',
                    icon: 'warning',
                    title: '<h2>Oops, Gagal</h2>',
                    html: '<h5>Beberapa input tidak boleh kosong!</h5>',
                    showConfirmButton: false,
                    timer: 3000
                })
                // setDisabled(false)
            } else {
                // alert('masuk bawah')
                // return false
                const formData = new FormData()
                formData.append('firstNamePic', NamaDepan)
                formData.append('lastNamePic', NamaBelakang)
                formData.append('emailPic', EmailPic)
                formData.append('mobilePhonePic', HpPic)
                formData.append('companyNamePic', NamaDepan + ` ` + NamaBelakang)
                formData.append('identityTypePic', IdentityType)
                formData.append('identityNumberPic', IdentityNumber)
                formData.append('jobPic', Job)
                formData.append('jobPositionPic', JobPosition)
                formData.append('companyName', NamaPerusahaan)
                formData.append('companyType', 'individual')
                formData.append('companyIndustryClassification', '-')
                formData.append('companyNpwpNumber', '-')
                formData.append('companyEmail', EmailPic)
                formData.append('companyPhone', '-')
                formData.append('companyMobilePhone', '-')
                formData.append('companyBillingCountry', 'Indonesia')
                formData.append('companyBillingState', '-')
                formData.append('companyBillingCity', '-')
                formData.append('companyBillingSubdistrict', '-')
                formData.append('companyBillingStreet', '-')
                formData.append('companyBillingZip', '-')
                formData.append('companyShippingCountry', '-')
                formData.append('companyShippingState', '-')
                formData.append('companyShippingCity', '-')
                formData.append('companyShippingSubdistrict', '-')
                formData.append('companyShippingStreet', '-')
                formData.append('companyShippingZip', '-')
                formData.append('identityFilePic', IdentityFile)
                formData.append('companyNpwpFile', IdentityFile)

                // Display the key/value pairs
                // for (var pair of formData.entries()) {
                //     console.log(pair[0] + ', ' + pair[1]);
                // }
                // return false

                const { data } = await axios({
                    url: `/users/users`,
                    method: 'PUT',
                    data: formData,
                    headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
                })

                // console.log(data)

                if (data.code === "200") {
                    setRequired(false)
                    MySwal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: '<h2>Sukses</h2>',
                        html: '<h5>Berhasil menyimpan data!</h5>',
                        showConfirmButton: false,
                        timer: 3000
                    })
                    setTimeout(() => {
                        props.close()
                        // setDisabled(false)
                    }, 3000);
                }
            }
        } catch (err) {
            setRequired(true)
            errorHandler({ err: err?.response?.data || err })
            // setDisabled(false)
            console.log(err)
        }
    }

    const fetchProvinsi = async () => {
        try {
            const options = {
                url: '/locations/states',
                method: 'GET'
            }
            const { data } = await axios(options)
            // console.log(data)
            setProvinces(data.data)

        } catch (err) {
            if (err) {
                console.log(err?.response?.data)
                // errorHandler({ err: err?.response?.data || err })
            }
        }
    }

    const fetchKota = async (idProvinsi) => {
        try {
            const options = {
                url: `/locations/cities?stateId=${idProvinsi}`,
                method: 'GET'
            }
            const { data } = await axios(options)
            // console.log(data)
            setCities(data.data)

        } catch (err) {
            if (err) {
                console.log(err?.response?.data)
                // errorHandler({ err: err?.response?.data || err })
            }
        }
    }

    const fetchSubDistricts = async (idCity) => {
        try {
            const options = {
                url: `/locations/subdistricts?cityId=${idCity}`,
                method: 'GET'
            }
            const { data } = await axios(options)
            // console.log(data)
            setSubDistricts(data.data)

        } catch (err) {
            if (err) {
                console.log(err?.response?.data)
                // errorHandler({ err: err?.response?.data || err })
            }
        }
    }

    const handleChangeProvinsi = (e) => {
        const province = getIdProvinsi(provinces, e.target.value)

        // dispatch({ type: 'SET_PROVINSI_ID_PERUSAHAAN', 'value': e.target.value });
        setProvinsiIndividu(e.target.value)
        fetchKota(province[0].id)
    }

    const handleChangeKota = (e) => {
        const city = getIdKota(cities, e.target.value)

        // dispatch({ type: 'SET_KOTA_ID_PERUSAHAAN', 'value': e.target.value });
        setKotaIndividu(e.target.value)
        fetchSubDistricts(city[0].id)
    }

    const handleChangeKecamatan = (e) => {
        // dispatch({ type: 'SET_KECAMATAN_ID_PERUSAHAAN', 'value': e.target.value });
        setKecamatanIndividu(e.target.value)
    }

    useEffect(() => {
        fetchProvinsi()
        fetchKota(props.user.Account.billingState)
        fetchSubDistricts(props.user.Account.billingCity)
    }, [])

    return (
        <>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="namaDepan" className="col-form-label">Nama Depan</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setNamaDepan(e.target.value)} style={{ fontSize: '14px', color: '#191919', fontWeight: '500' }} type="text" className="form-control form-control-white" id="namaDepan" value={NamaDepan} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: (NamaBelakang.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="namaBelakang" className="form-label required">Nama Belakang</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setNamaBelakang(e.target.value)} style={{ fontSize: '14px', borderColor: (NamaBelakang.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control form-control-white" id="namaBelakang" value={NamaBelakang} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: (HpPic.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="hpPic" className="form-label required">No Telepon/HP PIC</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setHpPic(e.target.value)} style={{ fontSize: '14px', borderColor: (HpPic.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control form-control-white" id="hpPic" value={HpPic} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="emailPic" className="col-form-label required">Email</label>
                </div>
                <div className='col-lg-7'>
                    <input style={{ fontSize: '14px', color: '#191919', fontWeight: '500' }} type="text" className="form-control" id="emailPic" value={props.user.email} disabled />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: (IdentityType.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="IdentityType" className="form-label required">Kartu Identitas</label>
                </div>
                <div className='col-lg-7'>
                    <select className="form-select" aria-label="Select example" id='IdentityType' onChange={(e) => setIdentityType(e.target.value)} value={IdentityType}
                        style={{ fontSize: '14px', borderColor: (HpPic.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }}
                    >
                        <option value=''>Pilih</option>
                        <option value='NIK'>NIK</option>
                        <option value='NPWP'>NPWP</option>
                    </select>
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: (IdentityNumber.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="IdentityNumber" className="form-label required">Nomor Identitas (NIK/NPWP)</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setIdentityNumber(e.target.value)} style={{ fontSize: '14px', borderColor: (IdentityNumber.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control form-control-white" id="IdentityNumber" value={IdentityNumber} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="identityFile" className="form-label required">Upload File Kartu Identitas (NIK/NPWP)</label>
                </div>
                <div className='col-lg-7'>
                    <input style={{ fontSize: '14px', color: '#191919', fontWeight: '500' }} type="file" className="form-control" id="identityFile" onChange={(e) => setIdentityFile(e.target.files[0])} />
                    <p className='mt-2' style={{ fontSize: '12px', color: '#5E6278', fontWeight: '500' }}>&nbsp;Format File .PDF, .PNG, .JPG, .JPEG</p>
                    {
                        IdentityFile.nama !== undefined ?
                            <div className='mb-3' style={{ color: '#0C86D9', fontWeight: '500' }}>{IdentityFile && `${IdentityFile.name} - ${IdentityFile.type}`}</div>
                            :

                            <a href={IdentityFile} download="IdentityFile" target="_blank" className="badge bg-success">
                                Unduh
                            </a>

                    }
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: (Job.length === 0 && required === true) ? '#F1416C' : '#191919', fontWeight: '500' }} htmlFor="Job" className="form-label required">Pekerjaan</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setJob(e.target.value)} style={{ fontSize: '14px', borderColor: (Job.length === 0 && required === true) ? '#F1416C' : '', fontWeight: '500' }} type="text" className="form-control form-control-white" id="Job" value={Job} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="NamaPerusahaan" className="col-form-label">Nama Perusahaan</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setNamaPerusahaan(e.target.value)} style={{ fontSize: '14px', fontWeight: '500' }} type="text" className="form-control form-control-white" id="NamaPerusahaan" value={NamaPerusahaan} />
                </div>
            </div>
            <div className="mb-3 row">
                <div className='col-lg-5'>
                    <label style={{ fontSize: '15px', color: '#191919', fontWeight: '500' }} htmlFor="JobPosition" className="col-form-label">Jabatan</label>
                </div>
                <div className='col-lg-7'>
                    <input onChange={(e) => setJobPosition(e.target.value)} style={{ fontSize: '14px', fontWeight: '500' }} type="text" className="form-control form-control-white" id="JobPosition" value={JobPosition} />
                </div>
            </div>
            <hr></hr>
            <div className="mb-3 row d-flex" style={{ textAlign: 'right' }}>
                <div>
                    <button onClick={() => props.close()} className="btn btn-bg-white" style={{ marginRight: '10px' }}>Batal</button>
                    <button onClick={handleUpdate} className="btn btn-success" disabled={disabled}>
                        {
                            disabled === true ?
                                'Mohon tunggu...'
                                :
                                'Simpan Perubahan'
                        }
                    </button>
                </div>

            </div>
        </>
    )
}

export default FormEditPicIndividu
